module.exports = __webpack_public_path__ + "img/solution--fall-prevention.7316aea6.png";